import { useSelector } from 'react-redux';
import type { RootState } from '../store';

export function useCanUserLoginWithSalesforce(): boolean {
  return useSelector(({ userLoginProvider }: RootState) => {
    return userLoginProvider.userLoginProvider.provider.salesforce;
  });
}

export function useUserLoginProviderAccountId(): string {
  return useSelector(({ userLoginProvider }: RootState) => {
    return userLoginProvider.userLoginProvider.accountId;
  });
}
